// bao migrate skip
import * as ko from "knockout";
import BaoDialogViewModel from "../../../factories/bao-dialog";
class SummaryReportFilterTabDialog {
    Dialog: BaoDialogViewModel;
    TeamCalendarId: KnockoutObservable<string> = ko.observable();
    TeamCalendarName: KnockoutObservable<string> = ko.observable();
    HasPermissionEntryNew: KnockoutObservable<boolean> = ko.observable();
    HasPermissionEntryEdit: KnockoutObservable<boolean> = ko.observable();
    HasPermissionEntryRemove: KnockoutObservable<boolean> = ko.observable();
    HasPermissionEntryOpen: KnockoutObservable<boolean> = ko.observable();
    TeamCalendarSearcher: Bindings.baoSearcher;
    constructor(data: any, dialog: BaoDialogViewModel) {
        this.Dialog = dialog;
        $.extend(this, data);
        this.TeamCalendarSearcher = {
            SearchType: "TeamCalendar",
            ObjectId: this.TeamCalendarId,
            ObjectValue: "Name",
            AutoComplete: true,
            AutoSearch: true
        };
    }
}
export default SummaryReportFilterTabDialog;